import { useRef } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { HeaderWithDescription } from '../HeaderWithDescription';
import { type BoxData, type OurBoxesPageData } from '../../lib/types';
import styles from '../../styles/OurBoxes.module.css';
import { scrollToRef } from '../../lib/utils/scroll-to-ref';
import { AgeGroupImageButton } from './AgeGroupImageButton';
import { BoxCardList } from './BoxCardList';

type OurBoxesFlowOriginalProps = {
  readonly page: OurBoxesPageData;
  readonly boxes: BoxData[];
  readonly onOpenBox: (boxUrl: string) => void;
};

export function OurBoxesFlowOriginal(props: OurBoxesFlowOriginalProps) {
  const { page, boxes, onOpenBox } = props;

  const boxes0to12mthRef = useRef(null);
  const boxes1to2yrRef = useRef(null);
  const boxes2to3yrRef = useRef(null);
  const boxes3plusyrRef = useRef(null);

  return (
    <div className="text-center">
      <div className={styles.boxListGroupsContainer}>
        <Container className="py-4">
          <HeaderWithDescription
            title={page.step2DiscoverTitle}
            description={page.step2DiscoverDescription}
          />
          <Row className="mt-4" xs={1} lg={2}>
            <Col className="p-3">
              <AgeGroupImageButton
                small
                title={page.step2AgeGroup0to1}
                image={page.step2AgeGroup0to1Image}
                onClick={() => {
                  scrollToRef(boxes0to12mthRef);
                }}
              />
            </Col>
            <Col className="p-3">
              <AgeGroupImageButton
                small
                title={page.step2AgeGroup1to2}
                image={page.step2AgeGroup1to2Image}
                onClick={() => {
                  scrollToRef(boxes1to2yrRef);
                }}
              />
            </Col>
            <Col className="p-3">
              <AgeGroupImageButton
                small
                title={page.step2AgeGroup2to3}
                image={page.step2AgeGroup2to3Image}
                onClick={() => {
                  scrollToRef(boxes2to3yrRef);
                }}
              />
            </Col>
            <Col className="p-3">
              <AgeGroupImageButton
                small
                title={page.ageGroupPlus3}
                image={page.ageGroupPlus3Image}
                onClick={() => {
                  scrollToRef(boxes3plusyrRef);
                }}
              />
            </Col>
          </Row>
        </Container>
      </div>
      <div className={styles.boxListContainer}>
        <Container className="text-align py-4">
          <div ref={boxes0to12mthRef}>
            <BoxCardList
              boxes={boxes.filter(
                (box) => box.ageGroup && box.ageGroup.maxMonths <= 12
              )}
              title={page.step2AgeGroup0to1}
              description={page.step2AgeGroup0to1Description}
              imageUrl="/images/tribufetti-header-yellow.png"
              onOpenBox={onOpenBox}
            />
          </div>
          <div ref={boxes1to2yrRef}>
            <BoxCardList
              boxes={boxes.filter(
                (box) =>
                  box.ageGroup &&
                  box.ageGroup.minMonths >= 12 &&
                  box.ageGroup.maxMonths <= 24
              )}
              title={page.step2AgeGroup1to2}
              description={page.step2AgeGroup1to2Description}
              imageUrl="/images/tribufetti-header-orange.png"
              onOpenBox={onOpenBox}
            />
          </div>
          <div ref={boxes2to3yrRef}>
            <BoxCardList
              boxes={boxes.filter(
                (box) =>
                  box.ageGroup &&
                  box.ageGroup.minMonths >= 24 &&
                  box.ageGroup.maxMonths <= 36
              )}
              title={page.step2AgeGroup2to3}
              description={page.step2AgeGroup2to3Description}
              imageUrl="/images/tribufetti-header-blue.png"
              onOpenBox={onOpenBox}
            />
          </div>
          <div ref={boxes3plusyrRef}>
            <BoxCardList
              boxes={boxes.filter(
                (box) => box.ageGroup && box.ageGroup.minMonths >= 36
              )}
              title={page.ageGroupPlus3}
              description={page.ageGroupPlus3Description}
              imageUrl="/images/tribufetti-header-green.png"
              onOpenBox={onOpenBox}
            />
          </div>
        </Container>
      </div>
    </div>
  );
}
